import { getPlatform } from './platform';

const AdService = {
  initialized: false,

  async init() {
    const platform = getPlatform();
    if (platform === 'ios') {
      // Future: Initialize AdMob plugin
      // const { AdMob } = await import('@capacitor-community/admob');
      // await AdMob.initialize({ requestTrackingAuthorization: true });
      console.log('[AdService] iOS ad initialization scaffolded');
    } else {
      console.log('[AdService] Web mock ads initialized');
    }
    this.initialized = true;
  },

  async showInterstitial() {
    if (!this.initialized) await this.init();

    const platform = getPlatform();
    if (platform === 'ios') {
      // Future: Show AdMob interstitial
      // const { AdMob } = await import('@capacitor-community/admob');
      // await AdMob.showInterstitial();
      console.log('[AdService] iOS interstitial would show here');
      return;
    }

    // Web mock: log and delay
    console.log('[AdService] Interstitial ad displayed (mock)');
    await new Promise((resolve) => setTimeout(resolve, 1500));
  },

  async showRewarded() {
    if (!this.initialized) await this.init();

    const platform = getPlatform();
    if (platform === 'ios') {
      // Future: Show AdMob rewarded
      // const { AdMob } = await import('@capacitor-community/admob');
      // const result = await AdMob.showRewardVideoAd();
      // return { completed: result.type === 'rewarded' };
      console.log('[AdService] iOS rewarded ad would show here');
      return { completed: true };
    }

    // Web mock: log, delay, always return completed
    console.log('[AdService] Rewarded ad displayed (mock)');
    await new Promise((resolve) => setTimeout(resolve, 1500));
    return { completed: true };
  },

  isReady() {
    return this.initialized;
  },
};

export default AdService;
